// extracted by mini-css-extract-plugin
module.exports = {"content":"SmallWysiwyg-module--content--16eBJ"};